import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import backend from 'i18next-xhr-backend';
import * as storage from '../utils/storage';

const allowedLanguages = ['en', 'fr'];
const defaultLng = 'en';
let lng = defaultLng;

const storageLanguage = storage.getLanguage();

if (storageLanguage && allowedLanguages.indexOf(storageLanguage) > -1) {
    lng = storageLanguage;
}

i18n
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(backend)
    // connect with React
    .use(reactI18nextModule) // passes i18n down to react-i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: false,
        lng,
        fallbackLng: 'en',
        whitelist: ['en', 'fr'],

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        backend: {
            loadPath: 'locales/{{lng}}/{{ns}}.json?v=' + new Date().getMilliseconds(),
            requestOptions: {
                cache: 'no-store',
            },
        },

        // react-i18next options
        react: {
            wait: true
        }
    });

export default i18n;